import React, {useCallback} from 'react';
import {useHistory, useLocation} from 'react-router-dom';

import {useSelector} from '../../../state/hooks';
import type * as PanelTypes from '../../../state/views/panel/types';
import {getPanelLinkById} from '../../Panel/FullScreenPanel/fullScreenUtils';
import {useConfigXBounds} from '../../Panel/hooks/hooks';
import {usePanelSharedProps} from '../../Panel/hooks/usePanelSharedProps';
import {SharedPanelStateContextProvider} from '../../Panel/SharedPanelStateContext';
import {default as PanelRunsLinePlot} from '../../PanelRunsLinePlot/ComponentWrapper';
import {type RunsLinePlotConfig} from '../../PanelRunsLinePlot/types';

export type LinePlotPanelEditorPanelProps = {
  panelRef: PanelTypes.Ref;
};

export const LinePlotPanelEditorWrapper = ({
  panelRef,
}: LinePlotPanelEditorPanelProps) => {
  const props = usePanelSharedProps(panelRef);
  const configXBounds = useConfigXBounds(panelRef);

  const history = useHistory();
  const location = useLocation();
  const panelId = useSelector(
    state => state.views.parts[panelRef.type][panelRef.id].__id__
  );

  // a name-based fullscreen url 404s once an edit changes the panel's name, so
  // flip to the stable id url first (like the modal's OK handler). guard on the
  // url param, not isAuto, since a non-auto panel can be on a name url too.
  const baseUpdateConfig = props.updateConfig as (
    config: RunsLinePlotConfig
  ) => void;
  const updateConfig = useCallback(
    (config: RunsLinePlotConfig) => {
      if (new URLSearchParams(location.search).has('panelDisplayName')) {
        history.replace(getPanelLinkById(panelId, location));
      }
      baseUpdateConfig(config);
    },
    [baseUpdateConfig, location, history, panelId]
  );

  return (
    <SharedPanelStateContextProvider config={configXBounds}>
      <PanelRunsLinePlot
        {...props}
        configMode={true}
        showDrawer={true}
        currentHeight={0}
        dimensions={undefined as any}
        pageQuery={props.pageQuery}
        config={props.config as RunsLinePlotConfig}
        updateConfig={updateConfig}
      />
    </SharedPanelStateContextProvider>
  );
};
